import React from "react";

class HeroImage extends React.Component {

    render() {

        return (
          this.props.title === 'PLACEHOLDER' ? (
            <div className={"rob-hero rob-hero--short"} style={{backgroundImage: `url(${this.props.url})`}}>
            </div>
          ):(
            <div className={"rob-hero"} style={{backgroundImage: `url(${this.props.url})`}}>
            </div>
          )
        )
    }
}

HeroImage.defaultProps = {
    url: '',
    title: '',
}

export default HeroImage;




// WEBPACK FOOTER //
// ./src/components/elements/HeroImage.js